import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import { SvgIcon } from '../../../../../../../common/react/components/SvgIcon';

export const NavItem = ( { path, icon, translationLabel } ) => {
    // @ts-ignore
    const text = PULSE.I18N.lookup( translationLabel );

    return (
        <li>
            <NavLink
                exact
                to={ path }
                className='statspro-nav-item'
                activeClassName='active'
                title={ text }
            >
                <div className="statspro-nav-item__content-wrapper">
                    <SvgIcon
                        icon={ icon }
                        className='statspro-nav-item__icon'
                    />
                    { text }
                </div>
            </NavLink>
        </li>
    );
};

NavItem.propTypes = {
    path: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    translationLabel: PropTypes.string.isRequired,
};